import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';


@Injectable()
export class DateConvertService implements NgbDateAdapter<string> {

  fromModel(value: string): NgbDateStruct {
    const dateValue = value.split('-');
    return {
      day: parseInt(dateValue[2], 10),
      month: parseInt(dateValue[1], 10),
      year: parseInt(dateValue[0], 10)
    };
  }

  toModel(value: NgbDateStruct) {
    return value.year + '-' + ('00' + value.month).slice(-2) + '-' + ('00' + value.day).slice(-2);
  }

}
